import {Outlet, useLocation} from 'react-router';

import ErrorHandler from '../../pages/shared/error-handler';

/**
 * The layout of the pages without a logged in user: the login page and the not found page. Each page brings its own
 * layout, the login page the same `.shell` as a logged in user (see `app-admin.tsx`).
 */
export const AppLogin = (): React.JSX.Element => {
    const {pathname} = useLocation();

    return (
        <ErrorHandler key={pathname}>
            <div className="page-fade-in">
                <Outlet />
            </div>
        </ErrorHandler>
    );
};
